import Loader from "@/components/Global/Loader";
import { useSearchParams } from "react-router-dom";

export default function Tearsheet() {
  const [searchParams] = useSearchParams();
  const pdfBlob = searchParams.get("pdf");
  return (
    <div className="w-full h-screen">
      {pdfBlob ? (
        <iframe width="100%" height="100%" title="PDF Preview" src={pdfBlob} />
      ) : (
        <div className=" flex justify-center">
          <Loader />
        </div>
      )}
    </div>
  );
}
